import { Flex, Text, Image, HStack, Box, Stack } from '@chakra-ui/react';
import useNowPlaying from 'hooks/use-now-playing';
import React from 'react';
import ScrollingText from 'components/NowPlaying/ScrollingText';
import ohanaSing from '../../../../assets/images/OhanaSing.png';

const MinimalNowPlaying: React.FC = () => {
  const { songName, singer } = useNowPlaying();
  return (
    <Flex
      fontFamily="'Kosugi Maru', sans-serif"
      p={2}
      gap={4}
      position="relative"
      align="flex-end"
      borderRadius="md"
      border="2px"
      borderColor="hana.700"
      minW="300px"
      h="80px"
      bg="rgba(255, 255, 255, 1)"
    >
      <HStack align="center" gap="1" w="300px">
        <Image src={ohanaSing} boxSize="75px" flexShrink={0} />
        <Stack flex={1} minW={0} overflow="hidden" whiteSpace="nowrap">
          <Text
            top="8px"
            letterSpacing="2px"
            fontSize="12px"
            px="2"
            color="pink"
            position="relative"
            zIndex="20"
            fontWeight="bold"
            sx={{
              '-webkit-text-stroke-width': '0.1px',
              '-webkit-text-stroke-color': 'hana.700',
            }}
          >
            Now Playing...
          </Text>
          <Box w="100%" minW={0} px={2}>
            <ScrollingText
              color="brown"
              fontSize="md"
              fontWeight="500"
              sx={{ WebkitTextStroke: '0.5px brown' }}
            >
              {songName}
            </ScrollingText>
            {singer && (
              <ScrollingText
                color="brown"
                fontSize="sm"
                fontWeight="300"
                sx={{ WebkitTextStroke: '0.5px brown' }}
              >
                {singer}
              </ScrollingText>
            )}
          </Box>
        </Stack>
      </HStack>
    </Flex>
  );
};

export default MinimalNowPlaying;
